import React, { useEffect, useState } from 'react';
import { Star } from '../icons';
import * as api from '../../api/user-app-api';
import { Button } from '../common/Button';

export const Dashboard = ({ setView }) => {
    const [categories, setCategories] = useState([]);
    const [reviews, setReviews] = useState([]);
    const [offer, setOffer] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showCompleteProfileModal, setShowCompleteProfileModal] = useState(false);

    const fetchDashboardData = async () => {
        setLoading(true);
        try {
            const [catRes, reviewRes, offerRes] = await Promise.all([
                api.fetchCategories(),
                api.fetchCustomerReviews(),
                api.fetchActiveOffer()
            ]);

            // ✅ Adjusted handling since your PHP APIs return plain arrays, not { status, data }
            if (Array.isArray(catRes.data)) setCategories(catRes.data);
            else if (Array.isArray(catRes.data?.data)) setCategories(catRes.data.data);

            if (Array.isArray(reviewRes.data)) setReviews(reviewRes.data);
            else if (Array.isArray(reviewRes.data?.data)) setReviews(reviewRes.data.data);

            if (offerRes.data && typeof offerRes.data === 'object' && !Array.isArray(offerRes.data))
                setOffer(offerRes.data);
            else if (offerRes.data?.data)
                setOffer(offerRes.data.data);
        } catch (err) {
            console.error("Error loading dashboard data:", err);
            setError("Failed to load dashboard. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDashboardData();
    }, []);

    useEffect(() => {
        const needsProfileCompletion =
            localStorage.getItem('needsProfileCompletion') === 'true';
        if (needsProfileCompletion) {
            setShowCompleteProfileModal(true);
        }
    }, []);

    const Slider = () => (
        <div className="bg-[#01a499]/10 p-4 rounded-xl mb-6 shadow-inner">
            <h2 className="text-xl font-bold text-[#01a499] mb-2">
                {offer ? offer.title || "Special Offer!" : "Welcome to OzNULI!"}
            </h2>
            <p className="text-sm text-[#01a499]">
                {offer ? offer.description || "Exciting deals for recyclers!" : "Get up to 20% more for plastics and e-waste this week. Help us save the planet!"}
            </p>
            <div className="flex justify-end mt-3">
                <button
                    onClick={() => setView('cart')}
                    className="text-xs font-semibold text-[#01a499] border border-[#01a499] px-3 py-1 rounded-full hover:bg-[#01a499] hover:text-white transition"
                >
                    {offer ? offer.cta_text || "Book Now" : "Book Now"}
                </button>
            </div>
        </div>
    );

    const CategorySection = () => (
        <div className="mb-8">
            <h2 className="text-xl font-bold text-gray-800 mb-4">What would you like to sell?</h2>
            <div className="grid grid-cols-2 gap-4">
                {categories.map(cat => (
                    <div
                        key={cat.id}
                        onClick={() => setView('cart', { initialCategory: cat })}
                        className="flex flex-col items-center p-4 bg-white rounded-xl shadow-lg border border-gray-100 hover:shadow-xl transition duration-300 transform hover:-translate-y-1 cursor-pointer"
                    >
                        {cat.image_url ? (
                            <img
                                src={cat.image_url}
                                alt={cat.name}
                                className="w-12 h-12 object-cover mb-2"
                            />
                        ) : (
                            null
                        )}

                        <p className="text-center text-sm font-semibold text-gray-700">{cat.name}</p>
                        <p className="text-xs text-gray-500 mt-1">{cat.unit}</p>
                    </div>
                ))}
            </div>
        </div>
    );

    const ReviewSection = () => (
        <div className="mb-4">
            <h2 className="text-xl font-bold text-gray-800 mb-4">
                Happy Recyclers ({reviews.length})
            </h2>
            <div className="overflow-x-auto flex space-x-4 pb-2">
                {reviews.map((review, index) => (
                    <div key={index} className="flex-shrink-0 w-64 bg-white p-4 rounded-xl shadow-lg border border-gray-100">
                        <div className="flex items-center mb-2">
                            {Array(5).fill(0).map((_, i) => (
                                <Star key={i} className={`w-4 h-4 ${i < review.rating ? 'text-yellow-500' : 'text-gray-300'}`} />
                            ))}
                        </div>
                        <p className="font-semibold text-gray-700">{review.customer_name}</p>
                        <p className="text-sm text-gray-500 mt-1 line-clamp-3">"{review.comment}"</p>
                        {review.created_at && (
                            <p className="text-xs text-gray-400 mt-1">
                                {new Date(review.created_at).toLocaleDateString()}
                            </p>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );

    if (loading) return <div className="p-4 text-center">Loading Dashboard...</div>;
    if (error) return <div className="p-4 text-center text-red-600">{error}</div>;

    return (
        <div className="p-4 pt-0 mb-20 relative">
            {/* <Slider /> */}
            <CategorySection />
            {reviews.length>0 &&(<ReviewSection />)}
            <p className="mt-8 mb-8 text-center text-xs text-gray-500">
                Powered by Eco Friend Industries
            </p>

            {showCompleteProfileModal && (
                <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center px-4">
                    <div className="bg-white w-full max-w-sm rounded-2xl shadow-xl p-6 text-center">
                        <h3 className="text-xl font-bold text-gray-800 mb-2">
                            Complete Profile
                        </h3>
                        <p className="text-sm text-gray-600 mb-5">
                            Please complete your profile to continue with a better experience.
                        </p>
                        <Button type="submit" 
                        onClick={()=>{
                            setShowCompleteProfileModal(false);
                                setView('profile');
                                }} 
                                >
                                            Go to Profile
                                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
};
